// extracted by mini-css-extract-plugin
export default {"title":"w_-z","warning":"x_-z","sizeOptionsLegendText":"y_-z"};